export class ConstantsTexte {
  static readonly ANWENDUNGSNAME: string = "Geruchs-Abstandsrechner nach VDI 3894/2";
  static readonly ENTWICKLUNGSTEXT: string = ''; /* '(Testversion 22.09.2026, 1.1.0)'; */

  static readonly TOOLTIPTEXT_ZUSATZABSTAND: string =
    'Radius eines Kreises um den Emissionsschwerpunkt ES der gesamten Anlage,\n' +
    'der alle Quellen und Austrittsflächen der Emission in die offene Atmosphäre\n' +
    'umschließt.\nDer vorgeschlagene Wert überschätzt in der Regel den Zusatzabstand\n' +
    'und kann durch Eingabe korrigiert werden.' +
    '\n\nBei der Bearbeitung einer Berechnung kann es erforderlich sein, den\n' + 'korrigierten Wert erneut einzutragen';

  static readonly TOOLTIPTEXT_GEWICHTUNGSFAKTOR: string =
    'Größter tierartspezifischer Gewichtungsfaktor nach Geruchsimmissions-\n' +
    'Richtlinie (zwischen 0,4 und 1,5), der bei den Emissionsquellen festgelegt\n' + 'wurde.\n' + 'Der Wert kann verändert werden.' +
    '\n\nBei der Bearbeitung einer Berechnung kann es erforderlich sein, den\n' + 'korrigierten Wert erneut einzutragen';


}
